// extracted by mini-css-extract-plugin
module.exports = {"attachments_grand_container":"Attachments_attachments_grand_container__1JL64","attachments_container":"Attachments_attachments_container__3sJlB"};